var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"light-gray"},[_c(_vm.header,{ref:"headerRef",tag:"component",on:{"reDrawMemoImage":_vm.reDrawMemoImage,"emitReload":_vm.emitReload}}),_vm._v(" "),_vm._t("default"),_vm._v(" "),_c(_vm.footer,{tag:"component"})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-016df320","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layout/CommonLayout.vue
// module id = null
// module chunks = 